<template>
  <div class="flow-create-model-wrap">

    <el-form :model="formChild" :rules="rules" ref="formChild" label-width="100px" size="mini">

      <el-divider content-position="left">子模型信息</el-divider>

      <div class="wrap-item info-wrap">

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="模型名称" prop="model_name">
              <el-input class="form-input" v-model="formChild.model_name" autocomplete="off" :disabled="formChild.is_sync == 1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据库表名" prop="model_table">
              <el-input class="form-input" v-model="formChild.model_table" autocomplete="off" @change="checkModelTable" :disabled="formChild.is_sync == 1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模型分类" prop="category_id">
              <el-input class="form-input" v-model="formChild.category_id" autocomplete="off" :disabled="formChild.is_sync == 1"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </div>

      <el-divider content-position="left">子模型字段</el-divider>

      <el-button size="mini" type="primary" @click="editField(null)" icon="el-icon-plus" :disabled="formChild.is_sync == 1">添加模型字段</el-button>

      <div class="wrap-item field-wrap">

        <el-table :data="formChild.field_json" v-loading="loading" border style="width: 100%">
          <el-table-column prop="field_name" label="字段名称" align="center"></el-table-column>
          <el-table-column prop="field_description" label="字段描述" align="center"></el-table-column>
          <el-table-column prop="type" label="字段类型" align="center"></el-table-column>
          <el-table-column prop="is_null" label="允许空值" align="center">
            <template slot-scope="scope">
              {{scope.row.is_null ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column prop="field_name" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" v-if="scope.row.is_edit" @click="editField(scope.row)" :disabled="formChild.is_sync == 1">编辑</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" v-if="scope.row.is_del" @click="removeField(scope)" :disabled="formChild.is_sync == 1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>

      <div class="wrap-item opt-btns">

      </div>

    </el-form>

    <el-dialog title="编辑" :visible.sync="dialogVisibleField" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="formChild" ref="formChild" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="字段描述" prop="title">
            <el-input class="form-input" v-model="editForm.field_description" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段名称" prop="title">
            <el-input class="form-input" v-model="editForm.field_name" :disabled="field_is_edit" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段类型" prop="title">
            <!--            <el-input class="form-input" v-model="editForm.type" :disabled="field_is_edit" autocomplete="off"></el-input>-->
            <el-select v-model="editForm.type" :disabled="field_is_edit" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleField = false">取 消</el-button>
        <el-button type="primary" @click="saveField()" >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import Http from "../common/Http";
import {pinyin} from "pinyin-pro";

export default {
  name:"flow-create-model-child",
  props: ["parentValue", "index"],
  data () {

    let checkModelTable = (rule, value, callback) => {
      if (!value) return callback(new Error('数据库表名不能为空'));
      if(/^[a-z]+/.test(value) == false) return callback(new Error('数据库名必须以字母开头'));
      callback()
    }

    return {
      formChild: {},
      editForm: {},
      dialogVisibleField: false,
      activeField: null,
      field_is_edit: false,
      rules: {
        model_name: [
          { required: true, message: '请输入模型名称', trigger: 'blur' },
        ],
        model_table: [
          { required: true, validator: checkModelTable, trigger: 'blur' },
        ],
        // category_id: [
        //   { required: true, message: '请输入模型分类', trigger: 'blur' },
        // ]
      },
      loading: false,
      options: [{
        value: 'input',
        label: '输入框'
      }, {
        value: 'text',
        label: '文本'
      }, {
        value: 'date',
        label: '日期'
      }, {
        value: 'dateTime',
        label: '时间'
      }],
    }
  },
  computed: {
    editFieldName: function () {
      return this.editForm.field_description
    },
    editModelName: function () {
      return this.formChild.model_name
    }
  },
  watch: {
    editFieldName: function(n) {
      let pinyinName = pinyin(n, { toneType: 'num', type: 'array' });
      this.editForm.field_name = pinyinName.join("_");
    },
    editModelName: function(n) {
      let pinyinName = pinyin(n, { toneType: 'num', type: 'array' });
      this.formChild.model_table = pinyinName.join("_");
    }
  },
  beforeMount() {
    this.editForm = this.getEditFormData()
  },
  activated() {

    this.$refs.formChild.clearValidate();
    // 通过父组件传入的值，重新渲染
    let model = this.parentValue.model
    console.log(model)
    if (typeof model.model_child_json === 'undefined' || model.model_child_json.length === 0 || model.model_child_json[this.index] === '' ) {
      this.formChild = this.getFormData();
    } else {
      this.formChild = model.model_child_json[this.index];
    }
  },
  methods: {

    getFormData(data) {
      return Object.assign({
        model_id: 0,
        model_name: '',
        model_table: '',
        category_id: '',
        is_sync: 0,
        field_json: []
      }, data)
    },

    getEditFormData(data) {
      return Object.assign({
        field_name: '',
        field_description: '',
        type: '',
        is_del: true,
        is_edit: true,
        is_null: false,
        is_show: true,
        options: [],
      }, data)
    },

    // 修改字段
    editField(data) {
      this.field_is_edit = !!data
      this.activeField = data
      this.editForm = this.getEditFormData(data)
      this.dialogVisibleField = true
    },

    // 保存修改字段
    saveField() {
      if(this.activeField == null) {
        this.formChild.field_json.push(this.editForm)
      } else {
        Object.assign(this.activeField, this.editForm)
      }
      this.dialogVisibleField = false
      this.sendDataToParent()
    },

    // 移除字段
    removeField(data) {
      this.formChild.field_json.splice(data.$index, 1)
      this.sendDataToParent()
    },

    // 验证表单
    // validate(callback) {
    //
    //   this.$refs.form.validate((valid) => {
    //     if(valid) callback()
    //   });
    //
    // },

    // 检查数据库表名
    checkModelTable(callback) {

      Http.get("flow/FlowModel/checkModelTable", {model_id: this.formChild.model_id, model_table: this.formChild.model_table}, res => {
        if(res.code) {
          if(res.data.count > 0) {
            this.$message.warning('该数据库表名已存在，请重新填写')
            if(callback) callback(false)
          } else {
            if(callback) callback(true)
          }
        } else {
          this.$message.warning(res.msg)
          if(callback) callback(false)
        }
      })
    },

    // 把"parentValue", "index"返回到父组件
    sendDataToParent() {
      let data = {
        'formChild': this.formChild,
        'index': this.index
      }
      if (typeof this.parentValue.form.model_child_json === 'undefined' || this.parentValue.form.model_child_json === null) {
        this.parentValue.form.model_child_json = [];
      }
      if (this.parentValue.form.model_child_json[this.index] === 'undefined') {
        this.parentValue.form.model_child_json[this.index] = [];
      }
      this.parentValue.form.model_child_json[this.index] = this.formChild

      this.$emit('getChildData',data)
    }

  }
}
</script>
<style lang="scss" scoped>

@import '../common.scss';

.flow-create-model-wrap {
  padding: 10px 20px;

  .wrap-item {
    padding: 10px 0;
  }

  .info-wrap {
    margin-right: 30px;

    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }

  .opt-btns {
    text-align: center;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowCreateModelChild.vue